<template>
  <b-form-group :label="label" class="mb-0">
    <b-row>
      <b-col cols="6" class="pr-0">
        <b-form-select v-model="hour" :disabled="disabled" @change="hourSelected" :options="hours" />
      </b-col>

      <b-col cols="6" class="pl-0">
        <b-form-select
          v-model="minute"
          :options="minutes"
          :disabled="disabled"
          @change="minuteSelected"
        />
      </b-col>
    </b-row>

    <b-row v-if="displaySetNow">
      <b-col cols="12">
        <button class="btn btn-xs btn-outline-primary float-right" :disabled="disabled" @click.prevent="setNow">Ustaw teraz</button>
      </b-col>
    </b-row>
  </b-form-group>
</template>

<script>
/** Ustawienie czasu */
export default {
  props: {
    /* Nazwa pola **/
    label: String,
    /** Czy pole jest wyłączone */
    disabled: Boolean,
    /** Wartość do ustawienia */
    set: String,
    /** Czy wyświetlać przycisk ustawienia aktualnego czasu */
    displaySetNow: Boolean
  },
  data() {
    return {
      hours: [],
      minutes: [],
      hour: 8,
      minute: 0
    };
  },
  methods: {
    /** Przygotowanie listy minut */
    makeMinutes() {
      let mm = 0;
      for (mm = 0; mm <= 59; mm = mm + 1) {
        const MMstring = mm < 10 ? '0' + mm : '' + mm;
        this.minutes.push({ text: MMstring, value: mm });
      }
    },
    /** Przygotowanie listy godzin */
    makeHours() {
      let hh = 0;
      for (hh = 0; hh <= 23; hh = hh + 1) {
        const HHstring = hh < 10 ? '0' + hh : '' + hh;
        this.hours.push({ text: HHstring, value: hh });
      }
    },
    /** Emit wartości godzin */
    hourSelected(value) {
      this.emit(value, this.minute);
    },
    /** Emit wartości minut */
    minuteSelected(value) {
      this.emit(this.hour, value);
    },
    /** Emit czasu godzina:minuta */
    emit(hh, mm) {
      const min = mm < 10 ? '0' + mm : '' + mm;
      const hour = hh < 10 ? '0' + hh : '' + hh;
      this.$emit('time', hour + ':' + min);
    },
    /** Ustawienie czasu */
    setTime() {
      if (this.set) {
        const arr = this.set.split(':');
        this.hour = parseInt(arr[0], 10);
        this.minute = parseInt(arr[1], 10);
      } else if (this.displaySetNow) {
        this.setNow();
      }
    },
    /** Ustawienie aktualnego czasu */
    setNow() {
      const now = new Date();
      const hour = now.getHours();
      const minute = now.getMinutes();
      this.$set(this, 'hour', hour);
      this.$set(this, 'minute', minute);
      this.emit(this.hour, this.minute);
    }
  },
  beforeMount() {
    this.makeMinutes();
    this.makeHours();
  },
  mounted() {
    this.setTime();
    this.emit(this.hour, this.minute);
  }
};
</script>
<style>
select.form-control:disabled {
  background-color: lightgrey !important;
}
</style>
